var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-indicator-trends-create',{on:{"on-create":_vm.onConfirmHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }